<script>
import {COLORS} from "../services/StatusDataToChartData";

export default {
  name: "DevelopmentSuggestions",
  props: {
    childId: {
      type: Number,
      required: true
    },
    topics: {
      type: Array,
      required: false
    },
    developmentReportId: {
      type: Number,
      required: false
    },
    scrollable: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    developmentReportId() {
      this.loadSuggestions();
    }
  },
  data() {
    return {
      generating: false,
      loadedSuggestions: this.suggestions
    }
  },
  methods: {
    async loadSuggestions() {
      if (!this.developmentReportId) return;
      try {
        this.generating = true;
        const {data} = await axios.get(`/development-reports/${this.childId}/get-suggestions`,
            {params: {development_report_id: this.developmentReportId}})
        this.loadedSuggestions = data.data;
        this.generating = false;
      } catch (e) {
        this.generating = false;
      }
    },
    reload() {
      this.loadSuggestions();
    },
    getTopicColor(topic) {
      const index = this.topics?.findIndex(t => t.text.toLowerCase().includes(topic.toLowerCase()));

      return COLORS[index];
    }
  },
  async mounted() {
    await this.loadSuggestions();
  }
}
</script>

<template>
  <div class="w-100">
    <div class="header d-flex gap-3 mb-4 bg-light-blue">
      <div class="icon">
        <i class="text-primary fi-rr-magic-wand fs-1"></i>
      </div>
      <div>
        <h6 class="mb-0">
          {{ trans('general.dashboard.improvement_guide') }}
        </h6>
        <small class="text-gray-800">
          {{ trans('general.dashboard.suggestions') }}
        </small>
      </div>
    </div>
    <div :class="['text-gray-1000 scrollable px-1', scrollable ? 'h-295' : '']">
      <div v-if="!generating && loadedSuggestions">
        <div class="card card-border" v-for="(topic) in Object.keys(loadedSuggestions)">
          <div class="card-body">
            <div class="d-flex gap-2">
              <div class="bullet" :style="{ 'background-color': getTopicColor(topic) }"></div>
              <small class="card-title" :style="{color: getTopicColor(topic)}">{{ topic }}</small>
            </div>
            <div class="card-text">
              <ul>
                <li v-for="(suggestion, index) in loadedSuggestions[topic]" :key="index">{{ suggestion }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-grow-1 mw-5" v-else>
        <p class="placeholder-glow"><span class="placeholder bg-gray-400 col-12"></span></p>
        <p class="placeholder-glow"><span class="placeholder bg-gray-400 col-12"></span></p>
        <p class="placeholder-glow"><span class="placeholder bg-gray-400 col-12"></span></p>
        <p class="placeholder-glow"><span class="placeholder bg-gray-400 col-12"></span></p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.header {
  border-radius: 15px;
  padding: 10px;
}

.h-295 {
  max-height: 385px;
  overflow: auto;
  position: relative;
}

.h-295::after {
  content: "";
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: linear-gradient(to bottom, transparent, white);
  display: block;
}

.header .icon {
  line-height: 0;
}

.bullet {
  width: 15px;
  height: 15px;
  min-width: 15px;
  min-height: 15px;
  border-radius: 50%;
  display: inline-block;
}
</style>
